import { UUID } from "crypto";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { MouseEventHandler, ReactElement } from "react";

export enum AuthType {
	Admin = 'admins',
	Coordinator = 'coordinators'
}

export enum Roles {
	Root = 'Root',
	Admin = 'Admin',
	Coordinator = 'Coordinator'
}


export enum DataTableKey {
	Coordinators = 'Coordinator',
	Treatments = 'Treatments',
	TreatmentCourses = 'TreatmentCourses'
}


export type ToastData = {
	detail: string;
	severity: 'success' | 'info' | 'warn' | 'error';
	summary: string;
};


export enum TreatmentCourseStatus {
	Confirmed = 'Confirmed',
	Pending = 'Pending',
}

export type UserState = {
	accessToken: string;
	refreshToken: string;
	role: Roles
}


export type DataTableActionPayload = {
	key: DataTableKey;
	page: number;
	filters: any
}



export type UserInfo = {
	id: string;
	email: string;
	name: string;
};





export type AuthPayload = {
	target: AuthType;
	email: string;
	password: string;
};

export type Pagination = {
	first: number;
	totalRecords: number;
	totalPages: number;
	rowsPerPageOption: number[];
	onPageChange: (event: PaginatorPageChangeEvent) => void;
};


export type PaginatedResponse<T> = {
	totalPages: number;
	currentPage: number;
	totalItems: number;
	itemsPerPage: number;
	data: T[]

};

export type TableColumnFilter = {
	visibility: boolean;
	placeholder: string;
};

export type TableColumn = {
	field?: string;
	headerName: string;
	body?: any;
	filter?: TableColumnFilter;
	sortable?: boolean;
};


export type BaseTableProps = {
	storeKey:DataTableKey;
	columns: TableColumn[];
	emptyMessage: string;
	globalFilter?: boolean;
	globalButton?: { text: string; action: MouseEventHandler<HTMLButtonElement>; icon?: string; loading?: boolean };
	requestFunction?: any
	showPagination?: boolean;
	modifyFiltersKey?: Function;
	errorElement?: ReactElement
};





export type Treatment = {
	id: UUID;
	name: string;
	consentContent: string;
	coordinatorId: string;
	created_at: Date;
	updateded_at: Date;

}


export type Coordinator = {
	id: UUID;
	email: string;
	password: string;
	treatment: Treatment;
	treatmentId: string
	created_at: Date;
	updateded_at: Date;
}

export type Patient = {
	id: UUID;
	name: string;
	email: string;
	gender: string;
	mobile: string;
	address: string;
	nationalId: string;
	birthDate: Date;
	created_at: Date;
	updateded_at: Date;
}


export type TreatmentCourse = {
	id: string;
	startDate: Date;
	sign?: string;
	signDate?: Date;
	treatment: Treatment
	creator: Coordinator
	patient: Patient
}


export type TreatmentCoursesResponse = {
	id: string;
	startDate: Date | string;
	signDate: Date;
	created_at: Date;
	updated_at: Date;
	creator: string;
	patientName: string;
	patientId: string;
	status: TreatmentCourseStatus
}



export type TreatmentCourseFormData = {
	nationalId: string;
	name: string;
	treatmentId: string;
	startDate: Date

}
